import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Notification  {
    _originalTypeClassName = "zPMO.BO.Notification";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Notification.translate = translateService;
}
this.Id = null;
this.DateCreated = null;
this.IsRead = false;
this.Text = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateCreated:any;
IsRead:any;
Text:any;
Task:any;
User:any;
static setTask = ($this, value) => {
var oldValue = $this.Task;
$this.Task = value;
if (value != null) {
}
}
static setUser = ($this, value) => {
var oldValue = $this.User;
$this.User = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}